var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesignReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_805_1643)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2646 0.636353C13.6214 0.636353 12.2894 1.9684 12.2894 3.61156V5.09916H9.31418V8.07437C9.31418 8.89595 9.98021 9.56197 10.8018 9.56197H22.7026C23.5242 9.56197 24.1902 8.89595 24.1902 8.07437V5.09916H21.215V3.61156C21.215 1.9684 19.883 0.636353 18.2398 0.636353H15.2646ZM15.2646 5.09916C15.2646 4.27758 15.9306 3.61156 16.7522 3.61156C17.5738 3.61156 18.2398 4.27758 18.2398 5.09916C18.2398 5.92074 17.5738 6.58677 16.7522 6.58677C15.9306 6.58677 15.2646 5.92074 15.2646 5.09916ZM3.36377 6.58677H7.82658V8.07437C7.82658 9.71753 9.15863 11.0496 10.8018 11.0496H22.7026C24.3458 11.0496 25.6778 9.71753 25.6778 8.07437V6.58677H30.1406V33.3636H3.36377V6.58677ZM13.7986 12.9091H8.81831V17.8893H13.7986V12.9091ZM19.4903 12.9091H14.51V17.8893H17.3559L19.4903 15.7549V12.9091ZM20.2017 20.7352V23.581H25.1819V18.6008H22.3361L20.2017 20.7352ZM16.6444 18.6008H14.51V20.7352L16.6444 18.6008ZM19.4903 21.4466L17.3559 23.581H19.4903V21.4466ZM14.51 26.4269L16.6444 24.2925H19.4903V29.2727H14.51V26.4269ZM9.52978 28.5613L10.9527 24.2925H8.81831V29.2727H13.7986V27.1383L9.52978 28.5613ZM13.7986 21.4466L11.6642 23.581H8.81831V18.6008H13.7986V21.4466ZM22.3361 12.9091L20.2017 15.0435V12.9091H22.3361ZM25.1819 15.7549L22.3361 12.9091H25.1819V15.7549ZM25.1819 15.7549V17.8893H23.0476L25.1819 15.7549ZM20.2017 24.2925H25.1819V29.2727H20.2017V24.2925ZM20.5574 15.7549L22.3361 17.5336L14.1543 25.7154L12.3756 23.9367L20.5574 15.7549ZM21.2689 15.0435L22.3361 13.9763L24.1148 15.7549L23.0476 16.8221L21.2689 15.0435ZM11.6642 24.6482L13.4428 26.4269L11.6642 27.1383L10.9527 26.4269L11.6642 24.6482Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_805_1643"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.7273,
    height: 32.7273,
    fill: "white",
    transform: "translate(0.636475 0.636353)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignReport);
export default __webpack_public_path__ + "static/media/DesignReport.7a3723a596a86ed25b518853bf2ee8c0.svg";
export { ForwardRef as ReactComponent };